<section class="section py-6">
    <div class="columns">
      <div class="column header-title-page">
        <h2 class="title-header">Limpiezas</h2>
        <button class="button is-primary" (click)="openModal()">Nueva limpieza</button>
      </div>
    </div>
  </section>
  @if (isLoading) {
    <section class="section py-1">
        <app-spinner></app-spinner>
      </section>
  }

  @if (!isLoading) {
    <section class="section py-1">
        <div class="columns has-background-white">
          <div class="column">
            <div class="columns">
              <div class="column p-5">
                @if(cleanings) {
                  <div class="table-cleanings">
                    <app-generic-table [columnsHeader]="COLUMNS_HEADER" [dataTable]="cleanings"
                      (onSelectRow)="openModal($event)" (onDeleteItem)="delete($event)"></app-generic-table>
                  </div>
                }

              </div>
            </div>
          </div>
        </div>
      </section>
  }
  
  <div class="modal" [ngClass]="{'is-active': isModalActive }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <form [formGroup]="form" (ngSubmit)="onSave()">
        <header class="modal-card-head">
            @if(isCreating){
            <p class="modal-card-title">Nueva limpieza</p>
            } @else {
            <p class="modal-card-title">Limpieza: {{ form.value.id }}</p>
            }
          <button type="button" class="delete" aria-label="close" (click)="closeModal()"></button>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">Activa</label>
                <input id="isActiveSwitch" type="checkbox" name="isActiveSwitch" class="switch is-rounded"
                  formControlName="active">
                <label for="isActiveSwitch"></label>
              </div>
                  <div class="field">
                    <label class="label">Id</label>
                    <div class="control">
                      <input class="input" type="number" placeholder="Id" formControlName="id">
                    </div>
                  </div>

              <div class="field">
                <label class="label">Descripción</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Descripción" formControlName="name">
                </div>
              </div>
              <div class="field">
                <label class="label">Duración</label>
                <div class="control">
                  <input class="input" type="number" placeholder="Duración" formControlName="duration">
                </div>
              </div>
              <div class="field">
                <label class="label">Fecha inicio</label>
                <div class="control">
                  <input class="input" type="datetime-local" formControlName="fecha_inicio_blender">
                </div>
              </div>
              <div class="field">
                <label class="label">Fecha inicio</label>
                <div class="control">
                  <input class="input" type="datetime-local" formControlName="fecha_fin_blender" >
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot is-justify-content-space-between">
          <button type="button" class="button" (click)="closeModal()">Cancelar</button>
          <button type="submit" class="button is-primary" [disabled]="!form.valid">
            @if(isLoading) {
                <fa-icon [icon]="faSpinner"></fa-icon>
            } @else {
                <span>Guardar</span>
            }
          </button>
        </footer>
      </form>
    </div>
  </div>